export const HOURS_PER_DAY = 24
export const HOURS_PER_WEEK = HOURS_PER_DAY * 7

export const SECONDS_PER_HOUR = 60 * 60

export const MILLIS_PER_MINUTE = 1000 * 60
export const MILLIS_PER_HOUR = MILLIS_PER_MINUTE * 60
export const MILLIS_PER_DAY = MILLIS_PER_HOUR * 24
